import modal1Img from '../assets/modal1.png';
import card1Img from '../assets/card1.png';
import modal2Img from '../assets/modal2.jpg';
import card2Img from '../assets/card2.png';
import modal3Img from '../assets/modal3.png';
import card3Img from '../assets/card3.png';
import modal4Img from '../assets/modal4.jpg';
import card4Img from '../assets/card4.png';
import modal5Img from '../assets/modal5.png';
import card5Img from '../assets/card5.png';
import modal6Img from '../assets/modal6.jpg';
import card6Img from '../assets/card6.png';
import modal7Img from '../assets/modal7.png';
import card7Img from '../assets/card7.png';
import modal8Img from '../assets/modal8.jpg';
import card8Img from '../assets/card8.png';
import modal9Img from '../assets/modal9.png';
import card9Img from '../assets/card9.png';
import modal10Img from '../assets/modal10.jpg';
import card10Img from '../assets/card10.png';
import modal11Img from '../assets/modal11.png';
import card11Img from '../assets/card11.png';
import modal12Img from '../assets/modal12.jpg';
import card12Img from '../assets/card12.png';

export const PROJECTS = [
  {
    id: '1',
    title: 'ShoeBacca',
    description: "ShoeBacca is a sale platform for shoes in US. It has checkouts, auto payouts, dropshipping, event scheduling event, email marketing. I've worked here as a developer. I designed and developed the API's using GraplQL.",
    cardimage: {
      src: card1Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal1Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.shoebacca.com',
    },
    technologies: [
      '#html5',
      '#css3',
      '#react',
      '#redux',
      '#bootstrap',
      '#restapi',
      '#graphql'
    ],
  },
  {
    id: '2',
    title: 'Queen Garnet',
    description:
      'A “One Pager” is a Single Page website with no additional pages like About, Team or Services. All the content sits within the same webpage, traditionally in a long-scrolling layout. The beauty of a Single Page website is it tries to promote one thing in an uncluttered, direct manner. This allows the visitor to make a quicker decision vs sending them to a bloated website with many options and pages.',
    cardimage: {
      src: card2Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal2Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://queengarnet.com/'
    },
    technologies: [
      '#wordpress',
      '#jquery',
      '#nodejs',
      '#restapi',
      '#express',
      '#mysql',
      '#jwt'
    ],
  },
  {
    id: '3',
    title: 'Contiki Trip Guide',
    description: "Contiki is a New Zealand-based tour company. Contiki is a typical Webflow site that has many 3rd party Tour API's and Booking API's. I have customized some theme and develop several plugins.",
    cardimage: {
      src: card3Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal3Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.contiki.com/en-eu',
    },
    technologies: [
      '#webflow',
      '#graphql',
      '#aws',
      '#python',
      '#django',
      '#postgresql'
    ],
  },
  {
    id: '4',
    title: 'ACIST',
    description: 'ACIST is a pharmaceutical company. ACIST is a WP site has many custom plugins with calculator and price comparison.',
    cardimage: {
      src: card4Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal4Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.acist.com/'
    },
    technologies: [
      '#wordpress',
      '#php',
      '#vue',
      '#restapi',
      '#sqlite'
    ],
  },
  {
    id: '5',
    title: 'LeapFrog Baby Care',
    description: "LeapFrog is a trusted platform that encourage a child's curiosity and love of learning throughout their early developmental journey. For the good UI/UX, there are many 3rd party plugins.",
    cardimage: {
      src: card5Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal5Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.leapfrog.com/en-us/products/baby-care'
    },
    technologies: [
      '#javascript',
      '#react',
      '#redux',
      '#html5',
      '#css3',
      '#nodejs',
      '#mysql'
    ],
  },
  {
    id: '6',
    title: 'Canterbury Park',
    description: "Canterbury Park is wordpress website and destination for horse racing, card casino action, concerts, events and all-around entertainment. I have totally customized the theme and develop and customize plugins. There are so many 3rd party Casino API's, Horse Club API's and Scraping work is involved.",
    cardimage: {
      src: card6Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal6Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.canterburypark.com',
    },
    technologies: [
      '#react',
      '#redux',
      '#html5',
      '#css3',
      '#restapi'
    ],
  },
  {
    id: '7',
    title: 'Visit High Point',
    description: "Visit High Point is a platform to buy furniture, likes and more promotion services. There are many API's for a searchable furniture shopping Database.",
    cardimage: {
      src: card7Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal7Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://visithighpoint.com/'
    },
    technologies: [
      '#react',
      '#redux',
      '#python',
      '#django',
      '#postgresql',
      '#jwt',
      '#graphql'
    ],
  },
  {
    id: '8',
    title: 'Frontline Ticketing',
    description: "Frontline is a ticketing platform in US. It has checkouts, auto payouts, escrow, event scheduling event, email marketing, QR based event pass system and much more in it.",
    cardimage: {
      src: card8Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal8Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.frontlineticketing.com/',
    },
    technologies: [
      '#wordpress',
      '#jquery',
      '#restapi',
      '#php',
      '#laravel',
      '#aws'
    ],
  },
  {
    id: '9',
    title: 'Ayla Beauty',
    description: 'Ayla Beauty is a beauty shop located in CA, US.  It increases the chances of sales through high-quality leads. It provides filtered based search which is optimised and accurate for data selection.',
    cardimage: {
      src: card9Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal9Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://aylabeauty.com/'
    },
    technologies: [
      '#html5',
      '#css3',
      '#uve',
      '#bootstrap',
      '#python',
      '#django',
      '#sqlite'
    ],
  },
  {
    id: '10',
    title: 'Expandage',
    description: 'Expandage offers any business dealing with technology integration and automation a full service solution, with ASC, KYC and Satelment Automation areas for any business.',
    cardimage: {
      src: card10Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal10Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.leoboost.com/'
    },
    technologies: [
      '#javascript',
      '#react',
      '#redux',
      '#html5',
      '#css3'
    ],
  },
  
  {
    id: '11',
    title: 'EL GAUCHITO',
    description: 'EL GAUCHITO is a website for the restaurant where provide a little piece of Argentina. There are some 3rd party plugins for marketing, shipping, and management.',
    cardimage: {
      src: card11Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal11Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'http://elgauchitonyc.com/'
    },
    technologies: [
      '#wordpress',
      '#python',
      '#django',
      '#django',
      '#sqlite'
    ],
  },
  {
    id: '12',
    title: '2U Laundry',
    description: '2U Laundry is a laundry platform where you can simply register, pay and get your cloths ready. It is based on wordpress and fullly customized plugin. It has reminders, 3rd party APIs serives integration and a pricing management.',
    cardimage: {
      src: card12Img,
      placeholderSrc: 'There is only one image.'
    },
    modalimage: {
      src: modal12Img,
      placeholderSrc: 'There is only one image.'
    },
    links: {
      site: 'https://www.2ulaundry.com/'
    },
    technologies: [
      '#javascript',
      '#react',
      '#bootstrap',
      '#redux',
      '#html5',
      '#css3'
    ],
  }
];
